import VueClipboard from 'vue-clipboard2';
import Vue from 'vue';

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)